<template>
  <h4 style="margin-top: 20px">
    <span style="color: blue">Arms Counts</span>
  </h4>
  <div class="divLeft">
    <table>
      <thead>
        <tr>
          <th>Weapon</th>
          <th>Price</th>
          <th>Available</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>AR-15</td>
          <td>$1229</td>
          <td>16</td>
        </tr>
        <tr>
          <td>Glock 9mm</td>
          <td>$500</td>
          <td>10</td>
        </tr>
        <tr>
          <td>Swords</td>
          <td>$15</td>
          <td>6</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>Total</td>
          <td></td>
          <td>32</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="divRight" style="margin-right: 5px">
    <table>
      <thead>
        <tr>
          <th>Weapon</th>
          <th>Price</th>
          <th>Available</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>AR-15</td>
          <td>$1229</td>
          <td>16</td>
        </tr>
        <tr>
          <td>Glock 9mm</td>
          <td>$500</td>
          <td>10</td>
        </tr>
        <tr>
          <td>Swords</td>
          <td>$15</td>
          <td>6</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>Total</td>
          <td></td>
          <td>32</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
table {
  border: 2px solid #774f38;
  border-collapse: collapse;
  display: inline-table;
}
td {
  border: 1px solid #fa6900;
  padding: 5px 10px;
}
thead {
  background-color: #f1d4af;
}
tfoot {
  background-color: #c5e0dc;
}
.divLeft {
  text-align: left;
}
.divRight {
  text-align: right;
}
</style>
>
